// extracted by mini-css-extract-plugin
export default {"top_container":"painting_top_container__7sC8-","title":"painting_title__SEmHU","hero":"painting_hero__5FObY","image_container":"painting_image_container__Sbqj7"};